import { Component } from '@angular/core';

@Component({
  selector: 'gi-menu',
  templateUrl: 'menu.html'
})
export class MenuComponent {

}



// WEBPACK FOOTER //
// ./src/components/menu/menu.ts